import { Component, OnInit } from '@angular/core';
import { Router} from '@angular/router';

@Component({
    selector: 'app-default',
    templateUrl: './default.component.html',
    styleUrls: ['./default.component.scss'],
    standalone: false
})
export class DefaultComponent implements OnInit {

  sidebarOpen = true;
  constructor(public _router:Router) { }

  ngOnInit(): void {
  }
  sideBarToggler() {
    this.sidebarOpen = !this.sidebarOpen 
  }
}
